// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c74d2820","455":"38744db7","977":"cdba7a4b"}[chunkId] + ".chunk.js";
};